import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");

    if (!session_id) {
      navigate("/");
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        // Honour intentional post-login redirect (e.g. admin-modal Google sign-in routing to ops).
        // Read-and-clear so it only fires once.
        let next = "/dashboard";
        try {
          const stored = window.localStorage.getItem("post_auth_redirect");
          if (stored) {
            window.localStorage.removeItem("post_auth_redirect");
            // Only allow same-origin paths to prevent open-redirect abuse.
            if (typeof stored === "string" && stored.startsWith("/") && !stored.startsWith("//")) {
              next = stored;
            }
          }
        } catch {}
        navigate(next, { state: { user: res.data.user }, replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#0F0D0C] text-[#F5F2EB]">
      <div className="font-mono text-sm uppercase tracking-[0.3em] text-[#A39A8F]">
        <span className="inline-block w-2 h-2 bg-[#D95B38] mr-3 animate-pulse" />
        Authenticating…
      </div>
    </div>
  );
}
